const C = {
  name: "Prize",
  dimensions: { width: 24, height: 24 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4 1C4 0.447715 4.44772 0 5 0H15C15.5523 0 16 0.447715 16 1V3H19C19.5523 3 20 3.44772 20 4V6C20 8.44419 18.248 10.4777 15.9308 10.9136C15.5404 13.4659 13.5403 15.4903 11 15.9169V18H14C14.5523 18 15 18.4477 15 19C15 19.5523 14.5523 20 14 20H6C5.44772 20 5 19.5523 5 19C5 18.4477 5.44772 18 6 18H9V15.9169C6.45975 15.4903 4.45956 13.4659 4.06919 10.9136C1.75201 10.4777 0 8.44419 0 6V4C0 3.44772 0.447715 3 1 3H4V1ZM4 5H2V6C2 7.30702 2.83443 8.41796 4 8.82951V5ZM6 10V2H14V10C14 12.2077 12.2077 14 10 14C7.79228 14 6 12.2077 6 10ZM16 5V8.8295C17.1656 8.41796 18 7.30702 18 6V5H16Z" fill="currentColor"/>
    `
};
export {
  C as Prize
};
